/* Klecksy · Stage hero: cycles the world switcher. Pauses on hover/focus, when off-screen,
   and never auto-plays for visitors who prefer reduced motion. */
(() => {
  if (customElements.get('kx-stage')) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  // The serif line sits on cream: use the world's accent or ground colour, whichever reads (>= 3:1), else ink.
  const lum = (hex) => {
    const m = hex.trim().replace('#', '').match(/^([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
    if (!m) return null;
    const c = m.slice(1).map((h) => { const v = parseInt(h, 16) / 255; return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4; });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  };
  const CREAM = lum('#F7F2E8');
  const readable = (colors) => {
    for (const c of colors) {
      const l = lum(c);
      if (l !== null && (CREAM + 0.05) / (l + 0.05) >= 3) return c.trim();
    }
    return '#16130E';
  };

  class KxStage extends HTMLElement {
    connectedCallback() {
      this.i = 0;
      this.ms = Math.max(2000, parseInt(this.dataset.interval, 10) || 4000);
      this.style.setProperty('--kx-stage-ms', `${this.ms}ms`);
      this.chips = [...this.querySelectorAll('.kx-stage__chip')];
      this.count = this.chips.length;
      if (!this.count) return;
      this.chips.forEach((chip) => chip.addEventListener('click', () => { this.show(+chip.dataset.i); this.restart(); }));
      this.addEventListener('mouseenter', () => this.pause(true));
      this.addEventListener('mouseleave', () => this.pause(false));
      this.addEventListener('focusin', () => this.pause(true));
      this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.pause(false); });
      this.visible = true;
      new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; }).observe(this);
      this.show(0);
      this.restart();
    }
    show(i) {
      this.i = (i + this.count) % this.count;
      this.querySelectorAll('[data-i]').forEach((el) => {
        const on = +el.dataset.i === this.i;
        el.classList.toggle('is-active', on);
        if (el.classList.contains('kx-stage__chip')) el.setAttribute('aria-selected', on ? 'true' : 'false');
        if (el.classList.contains('kx-stage__frame')) {
          el.toggleAttribute('aria-hidden', !on);
          el.querySelector('a')?.setAttribute('tabindex', on ? '0' : '-1');
        }
      });
      const chip = this.chips[this.i];
      const cs = getComputedStyle(chip);
      this.style.setProperty('--kx-stage-accent', readable([cs.getPropertyValue('--kx-accent'), cs.getPropertyValue('--kx-bg')]));
      // restart the progress bar on the active chip
      const bar = chip.querySelector('.kx-stage__progress');
      if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
    }
    restart() {
      clearInterval(this.timer);
      if (reduce.matches) return;
      this.timer = setInterval(() => {
        if (!this.paused && this.visible && !document.hidden) this.show(this.i + 1);
      }, this.ms);
    }
    pause(on) {
      this.paused = on;
      this.classList.toggle('is-paused', on);
      if (!on) this.restart();
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  customElements.define('kx-stage', KxStage);
})();
